import {LatLng, LatLngBounds} from 'leaflet';

export const getLatLngBounds = (boundingBoxString:string) : LatLngBounds => {
  const parts:number[] = boundingBoxString.split(',').map((number) => Number(number));
  return new LatLngBounds(new LatLng(parts[1], parts[0]), new LatLng(parts[3], parts[2]));
};
